import { Dialog } from '@mui/material';
import { textStyleCss } from 'src/theme/atlas';
import styled from 'styled-components';

export const DeactivationContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const DeactivationText = styled.div`
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.bodySmall)}
  text-align: center;
  flex: 2;
`;

export const ToolTipWrapper = styled.div`
  flex: 1;
`;

export const ModalBody = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  @media (max-width: 800px) {
    flex-direction: column;
    width: 500px;
    max-width: 90%;
  }
`;

export const ModalTitle = styled.h2`
  padding-left: 20px;
  ${({ theme }) =>
    theme.isVaultVariant
      ? `font-family: ${theme.typography.fontFamily}; font-weight: 400;`
      : textStyleCss(theme.atlas.typography.semantic.headingH3)}
  color: ${(props) =>
    props.theme.isVaultVariant
      ? props.theme.newPalette.turquoise.T300
      : props.theme.atlas.semantic.color.type.default};
`;

export const ModalBodyRight = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px;
  flex-grow: 1;
  width: 50%;
  min-width: 300px;
  gap: 24px;
  font-family: ${(props) => props.theme.typography.fontFamily};
  border-left: 1px solid
    ${(props) =>
      props.theme.isVaultVariant
        ? props.theme.newPalette.turquoise.T300
        : props.theme.atlas.semantic.color.ui.divider.default};
  @media (max-width: 800px) {
    border-left: none;
    border-top: 1px solid
      ${(props) =>
        props.theme.isVaultVariant
          ? props.theme.newPalette.turquoise.T300
          : props.theme.atlas.semantic.color.ui.divider.default};
    height: 500px;
    width: 100%;
    min-width: 200px;
  }
`;

export const PermissionsLabel = styled.label.attrs<{
  'data-link-section-heading'?: boolean;
}>(() => ({
  'data-link-section-heading': true,
}))`
  ${({ theme }) =>
    theme.isVaultVariant
      ? `font-family: ${theme.typography.fontFamily};`
      : textStyleCss(theme.atlas.typography.semantic.body)}
  font-size: 16px;
  color: ${(props) =>
    props.theme.isVaultVariant
      ? props.theme.newPalette.turquoise.T300
      : props.theme.atlas.semantic.color.action.link.default};
`;

export const LinkSectionHeading = styled(PermissionsLabel).attrs<{
  'data-link-section-heading'?: boolean;
}>(() => ({
  'data-link-section-heading': true,
}))`
  color: ${(props) => props.theme.atlas.semantic.color.action.link.default};
`;

export const ModalLabelDescription = styled.div`
  ${({ theme }) =>
    theme.isVaultVariant
      ? `font-family: ${theme.typography.fontFamily}; font-weight: 300; font-size: 12px; color: grey;`
      : textStyleCss(theme.atlas.typography.semantic.caption)}
  ${({ theme }) =>
    !theme.isVaultVariant && `color: ${theme.atlas.semantic.color.type.muted};`}
  max-width: 250px;
`;

export const BottomBar = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 20px;
  padding: 20px;
  width: calc(100% - 40px);
  @media (max-width: 575px) {
    max-width: 300px;
    min-width: 220px;
    margin: 0 auto;
  }
`;

export const ButtonsContainer = styled.div`
  display: flex;
  gap: 20px;
  justify-content: center;
  padding-top: 20px;
  padding-bottom: 20px;
  @media (max-width: 575px) {
    flex-direction: column-reverse;
  }
`;

export const LabelAndToggle = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  label:not([data-link-section-heading]) {
    ${({ theme }) =>
      !theme.isVaultVariant &&
      `${textStyleCss(theme.atlas.typography.semantic.body)}
      color: ${theme.atlas.semantic.color.type.default};`}
  }
`;

export const StyledDialog = styled(Dialog)`
  root: {
    border: ${(props) =>
      `1px solid ${props.theme.atlas.semantic.color.ui.divider.default}`};
  }
`;
